import navigation from './navigation';
import menu from './menu';
import scroll from './scroll';

export default () => {
	navigation();
	menu();
	scroll();
};
